export const DISABLED_DATA_TEST_ID = 'create-collection-selector-modal-disabled'
export const CREATE_BUTTON_TEST_ID = 'create-collection-selector-modal-create-button'
